import { unwrap, orElse, defaultArg, bind, map } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { join, isNullOrWhiteSpace } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { FSharpChoice$5 } from "../fable_modules/fable-library-js.4.24.0/Choice.js";
import { singleton as singleton_1, ofArray, length } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { compare } from "../fable_modules/fable-library-js.4.24.0/Date.js";
import { utcNow } from "../fable_modules/fable-library-js.4.24.0/DateOffset.js";
import { createElement } from "react";
import React from "react";
import { Fetched$1_toOption_50D43789, useFeliz_React__React_useOptionalFetch_Static_5B82200F } from "../hooks/UseFetch.fs.js";
import { single } from "../Api/Actions.fs.js";
import { single as single_1 } from "../Api/ActionTypes.fs.js";
import { targetEntity } from "../Api/Entities.fs.js";
import { createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { Helpers_combineClasses } from "../fable_modules/Feliz.Bulma.3.0.0/./ElementBuilders.fs.js";
import { Fa_ISize, Fa_IconOption, Fa_i } from "../fable_modules/Fable.FontAwesome.3.0.0/FontAwesome.fs.js";
import { empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { EntityType__get_DomainEntity, Entity__get_Id, Entity__get_EntityType, SearchParams, InfoPanel, Feliz_Router_Router__Router_navigateQueryPath_Static_6F3B930F, EntityType__ToProperString, Target__get_Name, Target__get_Detail } from "../ClientTypes.fs.js";
import { defaultOf } from "../fable_modules/Feliz.2.9.0/../Feliz.Router.4.0.0/../fable-library-js.4.24.0/Util.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/./Interop.fs.js";
import { EPM_Domain_Events_DomainEntities__DomainEntities_ToProperString } from "../Prelude.fs.js";
import { toString } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { EntityIconDiv } from "../components/EntityIcon.fs.js";
import { single as single_2 } from "../Api/Subsystems.fs.js";
import { single as single_3 } from "../Api/Systems.fs.js";
import { DomainEntities } from "../DomainEvents.fs.js";
import "./SearchResult.scss";


function titleSwap(name, detail) {
    let detail_2;
    const trimName = name.trim();
    const trimDetail = map((d) => d.trim(), detail);
    let matchResult, detail_3, name_3, detail_4, name_4;
    if (trimDetail != null) {
        if (trimName === trimDetail) {
            matchResult = 0;
            detail_3 = trimDetail;
            name_3 = trimName;
        }
        else if ((detail_2 = trimDetail, isNullOrWhiteSpace(trimName))) {
            matchResult = 1;
            detail_4 = trimDetail;
            name_4 = trimName;
        }
        else {
            matchResult = 2;
        }
    }
    else {
        matchResult = 2;
    }
    switch (matchResult) {
        case 0:
            return [trimName, undefined];
        case 1:
            return [detail_4, undefined];
        default:
            return [trimName, trimDetail];
    }
}

function $007CCompletedOn$007CBehind$007CReadyToSign$007CStarted$007CWaiting$007C(activity, actionOpt) {
    let stepLength;
    if (activity.CompletedOn != null) {
        return new FSharpChoice$5(0, [undefined]);
    }
    else {
        const matchValue = activity.ExpectedCompletionDate;
        let matchResult, date_1;
        if (matchValue != null) {
            if (compare(matchValue, utcNow()) < 0) {
                matchResult = 0;
                date_1 = matchValue;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return new FSharpChoice$5(1, [undefined]);
            default: {
                const matchValue_1 = length(activity.Steps) | 0;
                let matchResult_1, action_2, stepLength_2, action_3, stepLength_3;
                if (actionOpt != null) {
                    if ((stepLength = (matchValue_1 | 0), (stepLength > 0) && (stepLength !== length(actionOpt.Steps)))) {
                        matchResult_1 = 0;
                        action_2 = actionOpt;
                        stepLength_2 = matchValue_1;
                    }
                    else if (matchValue_1 === length(actionOpt.Steps)) {
                        matchResult_1 = 1;
                        action_3 = actionOpt;
                        stepLength_3 = matchValue_1;
                    }
                    else {
                        matchResult_1 = 2;
                    }
                }
                else {
                    matchResult_1 = 2;
                }
                switch (matchResult_1) {
                    case 0:
                        return new FSharpChoice$5(3, [undefined]);
                    case 1:
                        return new FSharpChoice$5(2, [undefined]);
                    default:
                        return new FSharpChoice$5(4, [undefined]);
                }
            }
        }
    }
}

function ActivityResult(props) {
    let activePatternResult, children, children_2, children_4, children_6, action_2, elems_4;
    const action = useFeliz_React__React_useOptionalFetch_Static_5B82200F((actionId) => single(props.projectId, actionId), props.activity.ActionId, [props.projectId, props.activity.ActionId]);
    const actionOpt = (action.tag === 2) ? action.fields[0] : undefined;
    const actionTypeId = bind((a) => a.ActionTypeId, actionOpt);
    const actionType = useFeliz_React__React_useOptionalFetch_Static_5B82200F((actionTypeId_1) => single_1(props.projectId, actionTypeId_1), actionTypeId, [props.projectId, actionTypeId]);
    const target = useFeliz_React__React_useOptionalFetch_Static_5B82200F((tupledArg) => targetEntity(props.projectId, tupledArg[0], tupledArg[1]), map((te) => [te.EntityType, te.EntityId], props.activity.TargetEntity), [props.projectId, props.activity.TargetEntity]);
    const status = (activePatternResult = $007CCompletedOn$007CBehind$007CReadyToSign$007CStarted$007CWaiting$007C(props.activity, actionOpt), (activePatternResult.tag === 1) ? createElement("span", createObj(Helpers_combineClasses("icon", ofArray([["className", "is-medium"], ["className", "has-text-danger"], ["children", Fa_i(ofArray([new Fa_IconOption(11, ["fas fa-exclamation-circle"]), new Fa_IconOption(0, [new Fa_ISize(2, [])])]), [])]])))) : ((activePatternResult.tag === 3) ? createElement("span", createObj(Helpers_combineClasses("icon", ofArray([["className", "is-medium"], ["children", Fa_i(ofArray([new Fa_IconOption(11, ["fas fa-adjust"]), new Fa_IconOption(0, [new Fa_ISize(2, [])])]), [])]])))) : ((activePatternResult.tag === 2) ? createElement("span", createObj(Helpers_combineClasses("icon", ofArray([["className", "is-medium"], ["children", Fa_i(ofArray([new Fa_IconOption(11, ["fas fa-circle"]), new Fa_IconOption(0, [new Fa_ISize(2, [])])]), [])]])))) : ((activePatternResult.tag === 4) ? createElement("span", createObj(Helpers_combineClasses("icon", ofArray([["className", "is-medium"], ["children", Fa_i(ofArray([new Fa_IconOption(11, ["far fa-circle"]), new Fa_IconOption(0, [new Fa_ISize(2, [])])]), [])]])))) : createElement("span", createObj(Helpers_combineClasses("icon", ofArray([["className", "is-medium"], ["className", "has-text-success"], ["children", Fa_i(ofArray([new Fa_IconOption(11, ["fas fa-check-circle"]), new Fa_IconOption(0, [new Fa_ISize(2, [])])]), [])]]))))))));
    const targetOpt = (target.tag === 2) ? target.fields[0] : undefined;
    let patternInput;
    let matchResult, action_3;
    if (actionOpt == null) {
        if (props.activity.ActionId == null) {
            matchResult = 1;
        }
        else {
            matchResult = 2;
        }
    }
    else if ((action_2 = actionOpt, props.activity.ActionId != null)) {
        matchResult = 0;
        action_3 = actionOpt;
    }
    else {
        matchResult = 2;
    }
    switch (matchResult) {
        case 0: {
            let actionTypeText;
            const matchValue_2 = Fetched$1_toOption_50D43789(actionType);
            actionTypeText = ((matchValue_2 != null) ? (` (${matchValue_2.Name})`) : "");
            patternInput = [(children = toList(delay(() => append(singleton(action_3.Caption), delay(() => append(singleton(actionTypeText), delay(() => {
                const matchValue_3 = bind(Target__get_Detail, targetOpt);
                return (matchValue_3 == null) ? singleton(defaultOf()) : singleton(` ${matchValue_3} `);
            })))))), createElement("p", {
                children: reactApi.Children.toArray(Array.from(children)),
            })), (children_2 = toList(delay(() => {
                let matchValue_4;
                return append((matchValue_4 = props.activity.TargetEntity, (matchValue_4 == null) ? singleton(defaultOf()) : singleton(` ${EPM_Domain_Events_DomainEntities__DomainEntities_ToProperString(matchValue_4.EntityType)} : `)), delay(() => {
                    const matchValue_5 = map(Target__get_Name, targetOpt);
                    return (matchValue_5 == null) ? singleton(defaultOf()) : singleton(createElement("strong", {
                        children: [matchValue_5],
                    }));
                }));
            })), createElement("p", {
                children: reactApi.Children.toArray(Array.from(children_2)),
            }))];
            break;
        }
        case 1: {
            patternInput = [(children_4 = toList(delay(() => {
                let matchValue_6;
                return append((matchValue_6 = props.activity.Name, (matchValue_6 != null) ? singleton(matchValue_6) : singleton(defaultOf())), delay(() => {
                    const matchValue_7 = bind(Target__get_Detail, targetOpt);
                    return (matchValue_7 == null) ? singleton(defaultOf()) : singleton(` ${matchValue_7} `);
                }));
            })), createElement("p", {
                children: reactApi.Children.toArray(Array.from(children_4)),
            })), (children_6 = toList(delay(() => {
                let matchValue_8;
                return append((matchValue_8 = props.activity.TargetEntity, (matchValue_8 == null) ? singleton(defaultOf()) : singleton(` ${EPM_Domain_Events_DomainEntities__DomainEntities_ToProperString(matchValue_8.EntityType)} : `)), delay(() => {
                    let matchValue_9;
                    return append((matchValue_9 = map(Target__get_Name, targetOpt), (matchValue_9 == null) ? singleton(defaultOf()) : singleton(createElement("strong", {
                        children: [matchValue_9],
                    }))), delay(() => {
                        const matchValue_10 = props.activity.Detail;
                        return (matchValue_10 != null) ? singleton(matchValue_10) : singleton(defaultOf());
                    }));
                }));
            })), createElement("p", {
                children: reactApi.Children.toArray(Array.from(children_6)),
            }))];
            break;
        }
        default:
            patternInput = [defaultOf(), defaultOf()];
    }
    const tags = toList(delay(() => {
        let matchValue_11, action_4;
        return append((matchValue_11 = actionOpt, (matchValue_11 == null) ? singleton(defaultOf()) : ((action_4 = matchValue_11, append(singleton(createElement("span", createObj(Helpers_combineClasses("tag", ofArray([["children", toString(action_4.Maturity)], ["className", "is-dark"]]))))), delay(() => singleton(createElement("span", createObj(Helpers_combineClasses("tag", ofArray([["children", action_4.Name], ["className", "is-dark"]])))))))))), delay(() => {
            const matchValue_12 = actionType;
            return (matchValue_12.tag === 2) ? singleton(createElement("span", createObj(Helpers_combineClasses("tag", ofArray([["children", matchValue_12.fields[0].Name], ["className", "is-dark"]]))))) : singleton(defaultOf());
        }));
    }));
    const isLoading = action.tag === 1;
    return createElement("article", createObj(Helpers_combineClasses("media", ofArray([["className", join(" ", toList(delay(() => append(singleton("Activity"), delay(() => append(singleton(defaultArg(map((a_1) => (`maturity-${a_1.Maturity}`), actionOpt), "")), delay(() => (isLoading ? singleton("is-loading") : singleton("")))))))))], (elems_4 = toList(delay(() => {
        let elms_2;
        return append(singleton((elms_2 = ofArray([createElement("div", {
            className: "content",
            children: reactApi.Children.toArray([patternInput[0], patternInput[1]]),
        }), createElement("div", {
            className: "tags",
            children: reactApi.Children.toArray(Array.from(tags)),
        })]), createElement("div", {
            className: "media-content",
            children: reactApi.Children.toArray(Array.from(elms_2)),
        }))), delay(() => (props.showDetail ? singleton(createElement("div", {
            className: "media-right",
            children: reactApi.Children.toArray([status]),
        })) : empty())));
    })), ["children", reactApi.Children.toArray(Array.from(elems_4))])]))));
}

function ReferenceEntity(props) {
    let elems;
    return createElement("div", createObj(Helpers_combineClasses("level-item", ofArray([["onClick", props.onClick], (elems = [createElement("span", createObj(Helpers_combineClasses("icon", ofArray([["className", "is-small"], ["children", createElement(EntityIconDiv, {
        entityType: props.entityType,
        title: `${props.name} : ${EntityType__ToProperString(props.entityType)}`,
    })]])))), createElement("p", createObj(Helpers_combineClasses("title", ofArray([["className", "is-6"], ["children", props.name]]))))], ["children", reactApi.Children.toArray(Array.from(elems))])]))));
}

function TagResult(props) {
    let elms, elms_3, elms_1;
    const patternInput = titleSwap(props.tag.Detail, props.tag.Name);
    const subsystem = useFeliz_React__React_useOptionalFetch_Static_5B82200F((subsystemId) => single_2(props.projectId, subsystemId), props.tag.SubsystemId, [props.projectId, props.tag.SubsystemId]);
    const systemId = orElse((subsystem.tag === 2) ? subsystem.fields[0].SystemId : undefined, props.tag.SubsystemId);
    const system = useFeliz_React__React_useOptionalFetch_Static_5B82200F((systemId_1) => single_3(props.projectId, systemId_1), systemId, [props.projectId, systemId]);
    let systemReference;
    if (system.tag === 2) {
        const system_1 = system.fields[0];
        systemReference = createElement(ReferenceEntity, {
            entityType: "system",
            key: system_1.Id,
            name: system_1.Name,
            onClick: (e) => {
                e.preventDefault();
                Feliz_Router_Router__Router_navigateQueryPath_Static_6F3B930F(singleton_1(new SearchParams(4, [new InfoPanel(1, [system_1.Id, new DomainEntities(1, [])])])), false);
            },
        });
    }
    else {
        systemReference = defaultOf();
    }
    let subsystemReference;
    if (subsystem.tag === 2) {
        const subsystem_2 = subsystem.fields[0];
        subsystemReference = createElement(ReferenceEntity, {
            entityType: "subsystem",
            key: subsystem_2.Id,
            name: subsystem_2.Name,
            onClick: (e_1) => {
                e_1.preventDefault();
                Feliz_Router_Router__Router_navigateQueryPath_Static_6F3B930F(singleton_1(new SearchParams(4, [new InfoPanel(1, [subsystem_2.Id, new DomainEntities(2, [])])])), false);
            },
        });
    }
    else {
        subsystemReference = defaultOf();
    }
    const elms_4 = ofArray([(elms = toList(delay(() => append(singleton(createElement("figure", createObj(Helpers_combineClasses("image", ofArray([["className", "is-48x48"], ["children", createElement(EntityIconDiv, {
        entityType: "tag",
        title: EntityType__ToProperString("tag"),
    })]]))))), delay(() => (props.showDetail ? append(singleton(createElement("div", {
        className: join(" ", ["vertical-line", `type-${"tag"}`]),
    })), delay(() => singleton(createElement("p", {
        children: props.number,
    })))) : empty()))))), createElement("div", {
        className: "media-left",
        children: reactApi.Children.toArray(Array.from(elms)),
    })), (elms_3 = ofArray([(elms_1 = ofArray([createElement("p", createObj(Helpers_combineClasses("title", ofArray([["className", "is-spaced"], ["className", "is-6"], ["children", patternInput[0]]])))), createElement("p", createObj(Helpers_combineClasses("subtitle", ofArray([["className", "is-6"], ["children", defaultArg(patternInput[1], "")]]))))]), createElement("div", {
        className: "content",
        children: reactApi.Children.toArray(Array.from(elms_1)),
    })), createElement("nav", createObj(Helpers_combineClasses("level", toList(delay(() => append(singleton(["className", "is-mobile"]), delay(() => append(!props.showDetail ? singleton(["className", "is-hidden"]) : empty(), delay(() => {
        let elems_3;
        return singleton((elems_3 = [createElement("div", {
            className: "level-left",
            children: reactApi.Children.toArray([systemReference, subsystemReference]),
        })], ["children", reactApi.Children.toArray(Array.from(elems_3))]));
    })))))))))]), createElement("div", {
        className: "media-content",
        children: reactApi.Children.toArray(Array.from(elms_3)),
    }))]);
    return createElement("article", {
        className: "media",
        children: reactApi.Children.toArray(Array.from(elms_4)),
    });
}

function GenericResult(props) {
    let elms, elms_2, elms_1;
    const patternInput = titleSwap(props.name, props.detail);
    const elms_3 = ofArray([(elms = toList(delay(() => append(singleton(createElement("figure", createObj(Helpers_combineClasses("image", ofArray([["className", "is-48x48"], ["children", createElement(EntityIconDiv, {
        entityType: props.entityType,
        title: EntityType__ToProperString(props.entityType),
    })]]))))), delay(() => (props.showDetail ? append(singleton(createElement("div", {
        className: join(" ", ["vertical-line", `type-${props.entityType}`]),
    })), delay(() => singleton(createElement("p", {
        children: props.number,
    })))) : empty()))))), createElement("div", {
        className: "media-left",
        children: reactApi.Children.toArray(Array.from(elms)),
    })), (elms_2 = singleton_1((elms_1 = ofArray([createElement("p", createObj(Helpers_combineClasses("title", ofArray([["className", "is-spaced"], ["className", "is-6"], ["children", patternInput[0]]])))), createElement("p", createObj(Helpers_combineClasses("subtitle", ofArray([["className", "is-6"], ["children", defaultArg(patternInput[1], "")]]))))]), createElement("div", {
        className: "content",
        children: reactApi.Children.toArray(Array.from(elms_1)),
    }))), createElement("div", {
        className: "media-content",
        children: reactApi.Children.toArray(Array.from(elms_2)),
    }))]);
    return createElement("article", {
        className: "media",
        children: reactApi.Children.toArray(Array.from(elms_3)),
    });
}

export function SearchResult(props) {
    let content;
    const matchValue = props.entity;
    switch (matchValue.tag) {
        case 10: {
            content = createElement(ActivityResult, {
                activity: matchValue.fields[1],
                number: props.number,
                projectId: props.projectId,
                showDetail: props.showDetail,
            });
            break;
        }
        case 9: {
            content = createElement(ActivityResult, {
                activity: matchValue.fields[0],
                number: props.number,
                projectId: props.projectId,
                showDetail: props.showDetail,
            });
            break;
        }
        case 0: {
            content = createElement(GenericResult, {
                entityType: Entity__get_EntityType(props.entity),
                name: matchValue.fields[0].Name,
                number: props.number,
                showDetail: props.showDetail,
            });
            break;
        }
        case 1: {
            const m = matchValue.fields[0];
            content = createElement(GenericResult, {
                detail: m.Detail,
                entityType: Entity__get_EntityType(props.entity),
                name: m.Name,
                number: props.number,
                showDetail: props.showDetail,
            });
            break;
        }
        case 2: {
            const area = matchValue.fields[0];
            content = createElement(GenericResult, {
                detail: area.Detail,
                entityType: Entity__get_EntityType(props.entity),
                name: area.Name,
                number: props.number,
                showDetail: props.showDetail,
            });
            break;
        }
        case 3: {
            content = createElement(GenericResult, {
                entityType: Entity__get_EntityType(props.entity),
                name: matchValue.fields[0].Name,
                number: props.number,
                showDetail: props.showDetail,
            });
            break;
        }
        case 4: {
            const productionUnit = matchValue.fields[0];
            content = createElement(GenericResult, {
                detail: productionUnit.Detail,
                entityType: Entity__get_EntityType(props.entity),
                name: productionUnit.Name,
                number: props.number,
                showDetail: props.showDetail,
            });
            break;
        }
        case 5: {
            const system = matchValue.fields[0];
            content = createElement(GenericResult, {
                detail: system.Detail,
                entityType: Entity__get_EntityType(props.entity),
                name: system.Name,
                number: props.number,
                showDetail: props.showDetail,
            });
            break;
        }
        case 6: {
            const subsystem = matchValue.fields[0];
            content = createElement(GenericResult, {
                detail: subsystem.Detail,
                entityType: Entity__get_EntityType(props.entity),
                name: subsystem.Name,
                number: props.number,
                showDetail: props.showDetail,
            });
            break;
        }
        case 8: {
            const document$ = matchValue.fields[0];
            content = createElement(GenericResult, {
                detail: unwrap(document$.Detail),
                entityType: Entity__get_EntityType(props.entity),
                name: document$.Name,
                number: props.number,
                showDetail: props.showDetail,
            });
            break;
        }
        default:
            content = createElement(TagResult, {
                number: props.number,
                projectId: props.projectId,
                showDetail: props.showDetail,
                tag: matchValue.fields[0],
            });
    }
    return createElement("div", {
        onClick: (e) => {
            Feliz_Router_Router__Router_navigateQueryPath_Static_6F3B930F(singleton_1(new SearchParams(4, [new InfoPanel(1, [Entity__get_Id(props.entity), EntityType__get_DomainEntity(Entity__get_EntityType(props.entity))])])), false);
        },
        className: join(" ", toList(delay(() => append(singleton("search-result"), delay(() => (props.highlight ? singleton("highlighted") : empty())))))),
        children: content,
    });
}

